import { useEffect } from 'react';
// import { useLocation } from 'react-router';
// import { useWeb3React } from '@web3-react/core';
// import { Web3Provider } from '@ethersproject/providers';
// import { Contract, ethers } from 'ethers';
// import gameABI from '../../contracts/game/ABI';

interface IDJackEventLog {
  time: number;
  text: string;
}

interface IProps {
  djackEventsLog: IDJackEventLog[];
  setDjackEventsLog: React.Dispatch<React.SetStateAction<IDJackEventLog[]>>;
}

// interface IDJackEventDict {
//   [key: number]: string;
// }

// const shorter = (str: any) =>
//   str?.length > 8 ? `${str.slice(0, 5)}...${str.slice(-4)}` : str;

const DJackGameEventsLog: React.FC<IProps> = ({
  djackEventsLog,
  setDjackEventsLog
}: IProps) => {
  useEffect(() => {
    console.log(djackEventsLog);
    setDjackEventsLog([]);
  }, []);

  // // contract definition
  // const location = useLocation();
  // const path = location.pathname.split('/')[2].toLowerCase();

  // const { library } = useWeb3React<Web3Provider>();

  // const provider = new ethers.providers.StaticJsonRpcProvider(
  //   'https://data-seed-prebsc-1-s1.binance.org:8545/'
  // );

  // const contract = new Contract(
  //   path,
  //   gameABI.ABI,
  //   library?.getSigner() ? library?.getSigner() : provider
  // );

  // // contract events
  // const updateEventsLog = async (text: string) => {
  //   try {
  //     const fetchedCurrentBlock = await provider.getBlock('latest');
  //     const updatedTncEventsLog = [
  //       ...tncEventsLog,
  //       {
  //         time: fetchedCurrentBlock.number,
  //         text
  //       }
  //     ];
  //     setTncEventsLog(updatedTncEventsLog);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // const listener = (block: any, amount: any, log: any) => {
  //   const dict: ITncEventDict = {
  //     11: ' joined the game.',
  //     12: ' left the game.',
  //     13: 'The game has been started.',
  //     14: ' threw the ball.',
  //     15: ' caught the ball.',
  //     16: ' missed the ball.',
  //     17: ' claimed the prize due to opponent inactivity.',
  //     18: 'The prize has been claimed.'
  //   };
  //   if (log.event === 'GameLog') {
  //     const logType = log.args[1];
  //     const actor = log.args[0];
  //     const text = `${
  //       actor === ethers.constants.AddressZero ? '' : shorter(actor)
  //     }${dict[logType.toNumber()]}`;
  //     updateEventsLog(text);
  //   }
  // };

  // useEffect(() => {
  //   contract.on('GameLog', listener);
  //   return () => {
  //     contract.off('GameLog', listener);
  //   };
  // }, [library?.getSigner()]);

  return (
    // djackEventsLog.length === 0 ? (
    <div className="eventsLogTextDisabled">No events received yet...</div>
    // ) : (
    //   <div className="tncEventsLogContainer">
    //     <ul className="tncEventsLogList">
    //       {tncEventsLog.map((event, index) => (
    //         <li key={index}>
    //           <span className="tncEventsLogTime">{`#${event.time}: `}</span>
    //           <span className="tncEventsLogText">{event.text}</span>
    //         </li>
    //       ))}
    //     </ul>
    //   </div>
    // )
  );
};

export default DJackGameEventsLog;
